/**
 * i18n de Costos y stock (v3) — área PLATOS (la lista de inicio) y AJUSTES: claves cs.platos.* y cs.ajustes.*.
 * Paridad exacta es/en/pt (claves y placeholders {x}): la controla src/v2/i18n/parity.test.js.
 * Los prefijos por área los controla costsV3.test.js (dos áreas no pueden pisarse).
 *
 * Lo común (estados del plato, "Alcanza p/ 14", Guardar, Reintentar…) NO va acá: es cs.shell.*
 * y se lee con los helpers de v3/shell/labels.js.
 * Sin plurales automáticos: las que cambian con el número tienen .one / .other.
 */
const platos = {
  es: {
    // ── Encabezado
    "cs.platos.eyebrow": "Tus números",
    "cs.platos.title": "Platos",
    "cs.platos.sub": "Lo que te cuesta cada plato y lo que te queda.",
    "cs.platos.subStock": "Lo que te cuesta cada plato, lo que te queda y para cuántos te alcanza.",
    "cs.platos.act.contar": "Contar",
    "cs.platos.act.compra": "Cargar compra",

    // ── Números de arriba
    "cs.platos.kpi.queda.label": "Te queda por plato",
    "cs.platos.kpi.queda.avg": "en promedio",
    "cs.platos.kpi.queda.progress": "{n} de {total} costeados",
    "cs.platos.kpi.queda.short": "{n} de {total}",
    "cs.platos.kpi.queda.aria": "{n} de {total} platos costeados",
    "cs.platos.kpi.queda.costOne": "Costear el que falta",
    "cs.platos.kpi.queda.costMany": "Costear los {n} que faltan",
    "cs.platos.kpi.meta.label": "Tu meta",
    "cs.platos.kpi.meta.value": "Ingredientes: hasta {pct}% del precio",
    "cs.platos.kpi.meta.resale": "Bebidas y reventa: hasta {pct}%",
    "cs.platos.kpi.meta.short": "Meta: ingredientes hasta {pct}%",
    "cs.platos.kpi.meta.change": "Cambiar",
    "cs.platos.kpi.meta.changeAria": "Cambiar tu meta",
    "cs.platos.kpi.platos.one": "1 plato",
    "cs.platos.kpi.platos.other": "{n} platos",
    "cs.platos.kpi.see": "Ver cuáles",
    "cs.platos.kpi.revisar.label": "Para revisar",
    "cs.platos.kpi.revisar.none": "Ninguno",
    "cs.platos.kpi.revisar.sub": "te dejan menos de lo que querés",
    "cs.platos.kpi.revisar.subNone": "los costeados cumplen tu meta",
    "cs.platos.kpi.stock.label": "Stock",
    "cs.platos.kpi.stock.outNone": "Nada agotado",
    "cs.platos.kpi.stock.out.one": "1 sin stock",
    "cs.platos.kpi.stock.out.other": "{n} sin stock",
    "cs.platos.kpi.stock.low": "{n} para reponer",
    "cs.platos.kpi.stock.lowIncl": "{n} para reponer (con los sin stock)",
    "cs.platos.kpi.stock.uncounted": "{n} sin contar",
    "cs.platos.kpi.stock.see": "Ver insumos",
    "cs.platos.kpi.start.value": "Controlalo acá",
    "cs.platos.kpi.start.sub": "Baja solo con cada venta y el mozo ve \"Agotado\"",
    "cs.platos.kpi.start.link": "Empezar",
    "cs.platos.kpi.nodesc.label": "No descuentan",
    "cs.platos.kpi.nodesc.none": "Todos descuentan",
    "cs.platos.kpi.nodesc.sub": "que vendiste no bajan el stock",
    "cs.platos.kpi.nodesc.subNone": "lo que vendiste bajó el stock",
    "cs.platos.kpi.nodesc.subMissing": "no pudimos leer las ventas",
    "cs.platos.mstock.label": "Stock:",
    "cs.platos.mstock.start": "empezá a controlarlo",
    "cs.platos.reventa.only": "Mostrando sólo lo que revendés.",
    "cs.platos.reventa.all": "Ver todos",
    "cs.platos.stockLoading": "Leyendo el stock…",

    // ── Empezá acá
    "cs.platos.check.title": "Empezá acá · {done} de {total}",
    "cs.platos.check.sub": "Sabé cuánto te deja cada plato. Son unos 15 minutos.",
    "cs.platos.check.hide": "Ocultar",
    "cs.platos.check.done": "hecho",
    "cs.platos.check.tag": "Gestión",
    "cs.platos.check.count": "{n} de {total}",
    "cs.platos.check.goal.t": "Tu meta",
    "cs.platos.check.goal.d": "De cada $100 que cobrás, ¿cuánto querés gastar en ingredientes, como mucho?",
    "cs.platos.check.goal.done": "De cada $100 que cobrás, hasta {plata} en ingredientes.",
    "cs.platos.check.goal.other": "Otro",
    "cs.platos.check.goal.hint": "Lo común: entre $28 y $35.",
    "cs.platos.check.cost5.t": "Costeá {goal} platos",
    "cs.platos.check.cost5.d": "Arrancá por uno; al guardar, seguís con el próximo sin volver a la lista.",
    "cs.platos.check.cost5.first": "Costear el primero: {name}",
    "cs.platos.check.cost5.next": "Costear el próximo: {name}",
    "cs.platos.check.cost5.short": "Costear",
    "cs.platos.check.prices.t": "Revisá el precio de los {n} insumos que más pesan",
    "cs.platos.check.prices.tNone": "Revisá el precio de los insumos que más pesan",
    "cs.platos.check.prices.d": "Se abre \"Revisar precios\" con esos {n} ya cargados.",
    "cs.platos.check.prices.dNone": "Aparece cuando costees tus primeros platos.",
    "cs.platos.check.prices.cta": "Revisar precios",
    "cs.platos.check.stock.t": "Controlá tu stock",
    "cs.platos.check.stock.d": "10 minutos: elegís qué controlar, contás lo que hay y listo.",
    "cs.platos.check.stock.dCount.one": "Te falta contar 1 insumo.",
    "cs.platos.check.stock.dCount.other": "Te faltan contar {n} insumos.",
    "cs.platos.check.stock.cta": "Ver cómo",
    "cs.platos.check.stock.ctaCount": "Contar",
    "cs.platos.check.strip.one": "Te falta 1 paso:",
    "cs.platos.check.strip.other": "Te faltan {n} pasos:",
    "cs.platos.check.strip.stock": "Controlar el stock",
    "cs.platos.check.strip.count": "Contar el stock",
    "cs.platos.check.strip.aria": "Pasos que te faltan",

    // ── Avisos
    "cs.platos.alert.more.one": "y 1 más",
    "cs.platos.alert.more.other": "y {n} más",
    "cs.platos.alert.less": "Ocultar",
    "cs.platos.alert.open": "Ver avisos",
    "cs.platos.alert.count.one": "1 aviso",
    "cs.platos.alert.count.other": "{n} avisos",
    "cs.platos.alert.salesError": "No pudimos leer las ventas: el stock puede estar inflado.",
    "cs.platos.alert.salesErrorStale": "No pudimos leer las ventas nuevas: el stock puede estar inflado.",
    "cs.platos.alert.stockError": "No pudimos leer el stock. Recargá la página.",
    "cs.platos.alert.brokenUnit": "{plato}: \"{ing}\" está en {en} y lo comprás por {por}. No suma ni descuenta.",
    "cs.platos.alert.brokenGeneric": "{plato}: la unidad de \"{ing}\" no coincide con cómo lo comprás. No suma ni descuenta.",
    "cs.platos.alert.brokenDeleted": "{plato}: lleva un ingrediente que ya no existe. No suma.",
    "cs.platos.alert.brokenInner": "{plato}: el preparado \"{ing}\" tiene una línea que no suma.",
    "cs.platos.alert.noPrice.one": "{name} no tiene precio y lo usa 1 plato: queda incompleto.",
    "cs.platos.alert.noPrice.other": "{name} no tiene precio y lo usan {n} platos: quedan incompletos.",
    "cs.platos.alert.outOfStock": "{name}: sin stock.",
    "cs.platos.alert.oversold": "{name}: se vendió de más. Contalo de nuevo.",
    "cs.platos.alert.currency": "Tus costos están en {costs} y la carta en {menu}.",
    "cs.platos.alert.trackedUnused": "Controlás {name} pero ningún plato lo usa: sólo baja con lo que cargues a mano.",
    "cs.platos.alert.colors": "Cambiamos cómo se colorean los platos: ahora se compara sólo lo que gastás en ingredientes, y las bebidas tienen su propia meta.",
    "cs.platos.unitIn.g": "gramos",
    "cs.platos.unitIn.kg": "kilos",
    "cs.platos.unitIn.ml": "mililitros",
    "cs.platos.unitIn.l": "litros",
    "cs.platos.unitIn.u": "unidades",
    "cs.platos.unitIn.doc": "docenas",
    "cs.platos.unitBy.g": "gramo",
    "cs.platos.unitBy.kg": "kilo",
    "cs.platos.unitBy.ml": "mililitro",
    "cs.platos.unitBy.l": "litro",
    "cs.platos.unitBy.u": "unidad",
    "cs.platos.unitBy.doc": "docena",
    "cs.platos.fix.retry": "Reintentar",
    "cs.platos.fix.reload": "Recargar",
    "cs.platos.fix.fix": "Arreglar",
    "cs.platos.fix.price": "Poner precio",
    "cs.platos.fix.buy": "Cargar compra",
    "cs.platos.fix.count": "Contar",
    "cs.platos.fix.settings": "Ajustes",
    "cs.platos.fix.see": "Ver",
    "cs.platos.fix.ok": "Entendido",

    // ── Buscador, filtros y lista
    "cs.platos.search.placeholder": "Buscar plato o categoría…",
    "cs.platos.search.label": "Buscar plato o categoría",
    "cs.platos.search.clear": "Borrar búsqueda",
    "cs.platos.cat.label": "Categoría",
    "cs.platos.cat.all": "Categoría: todas",
    "cs.platos.filter.aria": "Filtrar platos",
    "cs.platos.filter.todos": "Todos",
    "cs.platos.filter.revisar": "Para revisar",
    "cs.platos.filter.sincostear": "Sin costear",
    "cs.platos.filter.bien": "Van bien",
    "cs.platos.filter.nodescuentan": "No descuentan",
    "cs.platos.list.aria": "Platos de la carta",
    "cs.platos.col.plato": "Plato",
    "cs.platos.col.costo": "Costo",
    "cs.platos.col.precio": "Precio",
    "cs.platos.col.queda": "Te queda",
    "cs.platos.col.stock": "Stock",
    "cs.platos.row.sizes": "{n} tamaños",
    "cs.platos.row.resale": "tal cual",
    "cs.platos.row.approx": "aproximado",
    "cs.platos.row.pct": "{pct}% ingred.",
    "cs.platos.row.suggest": "cobralo {plata}",
    "cs.platos.row.suggestLabel": "{label}: cobrá {plata}",
    "cs.platos.row.missing": "falta el precio de {name}",
    "cs.platos.row.noAmount": "falta la cantidad de {name}",
    "cs.platos.row.broken": "una línea no suma",
    "cs.platos.row.noPrice": "la carta no tiene precio",
    "cs.platos.row.sold": "vendiste {n}",
    "cs.platos.row.soldWhy": "vendiste {n} · {why}",
    "cs.platos.row.partial": "(lo demás sí descuenta)",
    "cs.platos.row.costear": "Costear",
    "cs.platos.row.costearAria": "Costear {name}",
    "cs.platos.count.one": "1 plato",
    "cs.platos.count.other": "{n} platos",

    // ── Vacíos
    "cs.platos.empty.menu.t": "Tu carta no tiene platos todavía",
    "cs.platos.empty.menu.d": "Cargalos en el editor y volvé acá para saber cuánto te deja cada uno.",
    "cs.platos.empty.menu.cta": "Ir al editor",
    "cs.platos.empty.all": "Ver todos",
    "cs.platos.empty.filter.t": "No hay platos con ese filtro",
    "cs.platos.empty.search.t": "No encontramos \"{q}\"",
    "cs.platos.empty.search.d": "Probá con otra palabra o con el nombre de la categoría.",
    "cs.platos.empty.revisar.t": "Nada para revisar",
    "cs.platos.empty.revisar.d": "Los platos que costeaste cumplen tu meta.",
    "cs.platos.empty.sincostear.t": "Ya costeaste todos tus platos",
    "cs.platos.empty.sincostear.d": "Cuando sumes uno a la carta, aparece acá.",
    "cs.platos.empty.bien.t": "Todavía ningún plato va bien",
    "cs.platos.empty.bien.d": "Costeá tus platos o revisá los que te dejan menos.",
    "cs.platos.empty.nodesc.t": "Todo lo que vendiste descuenta del stock",
    "cs.platos.empty.nodesc.d": "Si un plato vendido no baja el stock, aparece acá con el motivo.",

    // ── Ajustes
    "cs.ajustes.eyebrow": "Cómo calculamos",
    "cs.ajustes.title": "Ajustes",
    "cs.ajustes.sub": "Lo que cambies acá se aplica a todos los platos.",
    "cs.ajustes.saved": "Ajustes guardados",
    "cs.ajustes.chip": "{n}%",
    "cs.ajustes.meta.t": "Tu meta",
    "cs.ajustes.meta.example": "De cada {cobras} que cobrás, hasta {plata} en ingredientes.",
    "cs.ajustes.meta.cook.before": "Platos que cocinás: hasta",
    "cs.ajustes.meta.cook.after": "% del precio",
    "cs.ajustes.meta.cook.aria": "Meta de los platos que cocinás, en %",
    "cs.ajustes.meta.presets": "Metas comunes",
    "cs.ajustes.meta.resale.before": "Lo que revendés tal cual (bebidas, postres comprados): hasta",
    "cs.ajustes.meta.resale.after": "%",
    "cs.ajustes.meta.resale.aria": "Meta de lo que revendés tal cual, en %",
    "cs.ajustes.meta.hint": "Entre 10% y 80%. Lo común en cocina: entre 28% y 35%.",
    "cs.ajustes.meta.err": "Tiene que estar entre 10 y 80.",
    "cs.ajustes.meta.saved": "Tu meta quedó en {pct}%",
    "cs.ajustes.cats.t": "¿Qué categorías revendés?",
    "cs.ajustes.cats.d": "Sus platos se comparan con la meta de lo que revendés.",
    "cs.ajustes.cats.included": "Ya va con {name}",
    "cs.ajustes.cats.none": "Tu carta todavía no tiene categorías con platos.",
    "cs.ajustes.gastos.t": "Gastos de cocina",
    "cs.ajustes.gastos.d": "Gas, luz, descartables y condimentos. Se suma un % al costo de los ingredientes.",
    "cs.ajustes.gastos.before": "Sumá un",
    "cs.ajustes.gastos.after": "% a los ingredientes",
    "cs.ajustes.gastos.aria": "Gastos de cocina, en %",
    "cs.ajustes.gastos.err": "Tiene que estar entre 0 y 50.",
    "cs.ajustes.outOfRange": "Tenés guardado {pct}%: está fuera de {lo}–{hi}%. Si lo cambiás, tiene que quedar adentro.",
    "cs.ajustes.gastos.example": "Ej.: {plato} lleva {plata} en ingredientes → {extra} de gastos de cocina.",
    "cs.ajustes.gastos.exampleGeneric": "Ej.: un plato con {plata} en ingredientes → {extra} de gastos de cocina.",
    "cs.ajustes.gastos.noteStrong": "Sueldos y alquiler NO van acá:",
    "cs.ajustes.gastos.note": "salen de lo que te queda.",
    "cs.ajustes.stock.t": "Stock en la comanda",
    "cs.ajustes.stock.block": "No dejar vender lo agotado",
    "cs.ajustes.stock.on": "Prendido:",
    "cs.ajustes.stock.onD": "el mozo no puede cargar un plato sin stock.",
    "cs.ajustes.stock.off": "Apagado:",
    "cs.ajustes.stock.offD": "lo ve \"Agotado\" pero puede cargarlo igual.",
    "cs.ajustes.stock.savedOn": "Listo: lo agotado no se puede vender",
    "cs.ajustes.stock.savedOff": "Listo: lo agotado se puede cargar igual",
    "cs.ajustes.stock.loading": "Leyendo cómo está configurado…",
    "cs.ajustes.ignored.t": "Platos que no son comida",
    "cs.ajustes.ignored.d": "No avisar si no descuentan stock (envío, cubierto, propina).",
    "cs.ajustes.ignored.none": "Ninguno",
    "cs.ajustes.ignored.edit": "Elegir",
    "cs.ajustes.ignored.done": "Listo",
    "cs.ajustes.ignored.hint": "Tildá los que no llevan receta a propósito.",
    "cs.ajustes.ignored.search": "Buscar en la carta…",
    "cs.ajustes.ignored.empty": "No hay platos con ese nombre.",
    "cs.ajustes.ignored.more": "Hay {n} más: buscalos por nombre.",
    "cs.ajustes.pack.t": "Stock con Gestión del local",
    "cs.ajustes.pack.d": "El stock baja solo con cada venta, el mozo ve \"Agotado\" y contás la heladera en una planilla.",
    "cs.ajustes.pack.cta": "Consultar",
    "cs.ajustes.pack.ctaAria": "Consultar por WhatsApp (se abre en otra pestaña)",
    "cs.ajustes.pack.wa": "Hola! Quiero saber de Gestión del local para {local}: el stock que baja solo con cada venta.",
    "cs.ajustes.sheet.title": "Tu meta",
    "cs.ajustes.sheet.q": "De cada {cobras} que cobrás, ¿cuánto querés gastar en ingredientes, como mucho?",
    "cs.ajustes.sheet.other": "Otro",
    "cs.ajustes.sheet.otherLabel": "¿Cuánto, de cada $100?",
    "cs.ajustes.sheet.of100": "de $100",
    "cs.ajustes.sheet.echo": "De cada {cobras}, hasta {plata} en ingredientes ({pct}% del precio).",
    "cs.ajustes.sheet.echoNone": "Elegí un valor entre 10 y 80.",
    "cs.ajustes.sheet.hint": "Lo común: entre $28 y $35.",
    "cs.ajustes.sheet.resale": "Lo que revendés tal cual tiene su propia meta ({pct}%).",
    "cs.ajustes.sheet.resaleLink": "Cambiarla en Ajustes",
  },

  en: {
    "cs.platos.eyebrow": "Your numbers",
    "cs.platos.title": "Dishes",
    "cs.platos.sub": "What each dish costs you and what you keep.",
    "cs.platos.subStock": "What each dish costs you, what you keep and how many you can still make.",
    "cs.platos.act.contar": "Count",
    "cs.platos.act.compra": "Log a purchase",

    "cs.platos.kpi.queda.label": "You keep per dish",
    "cs.platos.kpi.queda.avg": "on average",
    "cs.platos.kpi.queda.progress": "{n} of {total} with a cost",
    "cs.platos.kpi.queda.short": "{n} of {total}",
    "cs.platos.kpi.queda.aria": "{n} of {total} dishes with a cost",
    "cs.platos.kpi.queda.costOne": "Cost the one left",
    "cs.platos.kpi.queda.costMany": "Cost the {n} left",
    "cs.platos.kpi.meta.label": "Your goal",
    "cs.platos.kpi.meta.value": "Ingredients: up to {pct}% of the price",
    "cs.platos.kpi.meta.resale": "Drinks and resale: up to {pct}%",
    "cs.platos.kpi.meta.short": "Goal: ingredients up to {pct}%",
    "cs.platos.kpi.meta.change": "Change",
    "cs.platos.kpi.meta.changeAria": "Change your goal",
    "cs.platos.kpi.platos.one": "1 dish",
    "cs.platos.kpi.platos.other": "{n} dishes",
    "cs.platos.kpi.see": "See which",
    "cs.platos.kpi.revisar.label": "To check",
    "cs.platos.kpi.revisar.none": "None",
    "cs.platos.kpi.revisar.sub": "leave you less than you want",
    "cs.platos.kpi.revisar.subNone": "the costed ones meet your goal",
    "cs.platos.kpi.stock.label": "Stock",
    "cs.platos.kpi.stock.outNone": "Nothing sold out",
    "cs.platos.kpi.stock.out.one": "1 out of stock",
    "cs.platos.kpi.stock.out.other": "{n} out of stock",
    "cs.platos.kpi.stock.low": "{n} to restock",
    "cs.platos.kpi.stock.lowIncl": "{n} to restock (incl. out of stock)",
    "cs.platos.kpi.stock.uncounted": "{n} not counted",
    "cs.platos.kpi.stock.see": "See supplies",
    "cs.platos.kpi.start.value": "Track it here",
    "cs.platos.kpi.start.sub": "It goes down with every sale and waiters see \"Sold out\"",
    "cs.platos.kpi.start.link": "Start",
    "cs.platos.kpi.nodesc.label": "Don't deduct",
    "cs.platos.kpi.nodesc.none": "All deduct",
    "cs.platos.kpi.nodesc.sub": "you sold don't lower the stock",
    "cs.platos.kpi.nodesc.subNone": "what you sold lowered the stock",
    "cs.platos.kpi.nodesc.subMissing": "we couldn't read the sales",
    "cs.platos.mstock.label": "Stock:",
    "cs.platos.mstock.start": "start tracking it",
    "cs.platos.reventa.only": "Showing only what you resell.",
    "cs.platos.reventa.all": "See all",
    "cs.platos.stockLoading": "Reading the stock…",

    "cs.platos.check.title": "Start here · {done} of {total}",
    "cs.platos.check.sub": "Know what each dish leaves you. It takes about 15 minutes.",
    "cs.platos.check.hide": "Hide",
    "cs.platos.check.done": "done",
    "cs.platos.check.tag": "Management",
    "cs.platos.check.count": "{n} of {total}",
    "cs.platos.check.goal.t": "Your goal",
    "cs.platos.check.goal.d": "Out of every $100 you charge, how much do you want to spend on ingredients, at most?",
    "cs.platos.check.goal.done": "Out of every $100 you charge, up to {plata} on ingredients.",
    "cs.platos.check.goal.other": "Other",
    "cs.platos.check.goal.hint": "Typical: between $28 and $35.",
    "cs.platos.check.cost5.t": "Cost {goal} dishes",
    "cs.platos.check.cost5.d": "Start with one; when you save, you move on to the next without going back to the list.",
    "cs.platos.check.cost5.first": "Cost the first one: {name}",
    "cs.platos.check.cost5.next": "Cost the next one: {name}",
    "cs.platos.check.cost5.short": "Cost",
    "cs.platos.check.prices.t": "Check the price of the {n} supplies that weigh most",
    "cs.platos.check.prices.tNone": "Check the price of the supplies that weigh most",
    "cs.platos.check.prices.d": "Opens \"Review prices\" with those {n} already loaded.",
    "cs.platos.check.prices.dNone": "Shows up once you cost your first dishes.",
    "cs.platos.check.prices.cta": "Review prices",
    "cs.platos.check.stock.t": "Track your stock",
    "cs.platos.check.stock.d": "10 minutes: pick what to track, count what you have and you're done.",
    "cs.platos.check.stock.dCount.one": "1 supply still needs a count.",
    "cs.platos.check.stock.dCount.other": "{n} supplies still need a count.",
    "cs.platos.check.stock.cta": "See how",
    "cs.platos.check.stock.ctaCount": "Count",
    "cs.platos.check.strip.one": "1 step left:",
    "cs.platos.check.strip.other": "{n} steps left:",
    "cs.platos.check.strip.stock": "Track your stock",
    "cs.platos.check.strip.count": "Count your stock",
    "cs.platos.check.strip.aria": "Steps left",

    "cs.platos.alert.more.one": "and 1 more",
    "cs.platos.alert.more.other": "and {n} more",
    "cs.platos.alert.less": "Hide",
    "cs.platos.alert.open": "See alerts",
    "cs.platos.alert.count.one": "1 alert",
    "cs.platos.alert.count.other": "{n} alerts",
    "cs.platos.alert.salesError": "We couldn't read the sales: the stock may be too high.",
    "cs.platos.alert.salesErrorStale": "We couldn't read the latest sales: the stock may be too high.",
    "cs.platos.alert.stockError": "We couldn't read the stock. Reload the page.",
    "cs.platos.alert.brokenUnit": "{plato}: \"{ing}\" is in {en} and you buy it by the {por}. It doesn't add up or deduct.",
    "cs.platos.alert.brokenGeneric": "{plato}: the unit of \"{ing}\" doesn't match how you buy it. It doesn't add up or deduct.",
    "cs.platos.alert.brokenDeleted": "{plato}: it has an ingredient that no longer exists. It doesn't add up.",
    "cs.platos.alert.brokenInner": "{plato}: the prep \"{ing}\" has a line that doesn't add up.",
    "cs.platos.alert.noPrice.one": "{name} has no price and 1 dish uses it: it's incomplete.",
    "cs.platos.alert.noPrice.other": "{name} has no price and {n} dishes use it: they're incomplete.",
    "cs.platos.alert.outOfStock": "{name}: out of stock.",
    "cs.platos.alert.oversold": "{name}: more was sold than you had. Count it again.",
    "cs.platos.alert.currency": "Your costs are in {costs} and the menu is in {menu}.",
    "cs.platos.alert.trackedUnused": "You track {name} but no dish uses it: it only goes down with what you enter by hand.",
    "cs.platos.alert.colors": "We changed how dishes are colored: now we only compare what you spend on ingredients, and drinks have their own goal.",
    "cs.platos.unitIn.g": "grams",
    "cs.platos.unitIn.kg": "kilos",
    "cs.platos.unitIn.ml": "milliliters",
    "cs.platos.unitIn.l": "liters",
    "cs.platos.unitIn.u": "units",
    "cs.platos.unitIn.doc": "dozens",
    "cs.platos.unitBy.g": "gram",
    "cs.platos.unitBy.kg": "kilo",
    "cs.platos.unitBy.ml": "milliliter",
    "cs.platos.unitBy.l": "liter",
    "cs.platos.unitBy.u": "unit",
    "cs.platos.unitBy.doc": "dozen",
    "cs.platos.fix.retry": "Try again",
    "cs.platos.fix.reload": "Reload",
    "cs.platos.fix.fix": "Fix",
    "cs.platos.fix.price": "Add price",
    "cs.platos.fix.buy": "Log a purchase",
    "cs.platos.fix.count": "Count",
    "cs.platos.fix.settings": "Settings",
    "cs.platos.fix.see": "See",
    "cs.platos.fix.ok": "Got it",

    "cs.platos.search.placeholder": "Search dish or category…",
    "cs.platos.search.label": "Search dish or category",
    "cs.platos.search.clear": "Clear search",
    "cs.platos.cat.label": "Category",
    "cs.platos.cat.all": "Category: all",
    "cs.platos.filter.aria": "Filter dishes",
    "cs.platos.filter.todos": "All",
    "cs.platos.filter.revisar": "To check",
    "cs.platos.filter.sincostear": "No cost yet",
    "cs.platos.filter.bien": "Doing well",
    "cs.platos.filter.nodescuentan": "Don't deduct",
    "cs.platos.list.aria": "Menu dishes",
    "cs.platos.col.plato": "Dish",
    "cs.platos.col.costo": "Cost",
    "cs.platos.col.precio": "Price",
    "cs.platos.col.queda": "You keep",
    "cs.platos.col.stock": "Stock",
    "cs.platos.row.sizes": "{n} sizes",
    "cs.platos.row.resale": "resold as is",
    "cs.platos.row.approx": "approximate",
    "cs.platos.row.pct": "{pct}% ingred.",
    "cs.platos.row.suggest": "charge {plata}",
    "cs.platos.row.suggestLabel": "{label}: charge {plata}",
    "cs.platos.row.missing": "{name} has no price",
    "cs.platos.row.noAmount": "{name} has no amount",
    "cs.platos.row.broken": "a line doesn't add up",
    "cs.platos.row.noPrice": "no price on the menu",
    "cs.platos.row.sold": "sold {n}",
    "cs.platos.row.soldWhy": "sold {n} · {why}",
    "cs.platos.row.partial": "(the rest does deduct)",
    "cs.platos.row.costear": "Cost it",
    "cs.platos.row.costearAria": "Cost {name}",
    "cs.platos.count.one": "1 dish",
    "cs.platos.count.other": "{n} dishes",

    "cs.platos.empty.menu.t": "Your menu has no dishes yet",
    "cs.platos.empty.menu.d": "Add them in the editor and come back to see what each one leaves you.",
    "cs.platos.empty.menu.cta": "Go to the editor",
    "cs.platos.empty.all": "See all",
    "cs.platos.empty.filter.t": "No dishes with that filter",
    "cs.platos.empty.search.t": "We couldn't find \"{q}\"",
    "cs.platos.empty.search.d": "Try another word or the category name.",
    "cs.platos.empty.revisar.t": "Nothing to check",
    "cs.platos.empty.revisar.d": "The dishes you costed meet your goal.",
    "cs.platos.empty.sincostear.t": "All your dishes have a cost",
    "cs.platos.empty.sincostear.d": "When you add one to the menu, it shows up here.",
    "cs.platos.empty.bien.t": "No dish is doing well yet",
    "cs.platos.empty.bien.d": "Cost your dishes or check the ones that leave you less.",
    "cs.platos.empty.nodesc.t": "Everything you sold deducts from stock",
    "cs.platos.empty.nodesc.d": "If a sold dish doesn't lower the stock, it shows up here with the reason.",

    "cs.ajustes.eyebrow": "How we calculate",
    "cs.ajustes.title": "Settings",
    "cs.ajustes.sub": "What you change here applies to every dish.",
    "cs.ajustes.saved": "Settings saved",
    "cs.ajustes.chip": "{n}%",
    "cs.ajustes.meta.t": "Your goal",
    "cs.ajustes.meta.example": "Out of every {cobras} you charge, up to {plata} on ingredients.",
    "cs.ajustes.meta.cook.before": "Dishes you cook: up to",
    "cs.ajustes.meta.cook.after": "% of the price",
    "cs.ajustes.meta.cook.aria": "Goal for the dishes you cook, in %",
    "cs.ajustes.meta.presets": "Common goals",
    "cs.ajustes.meta.resale.before": "What you resell as is (drinks, bought desserts): up to",
    "cs.ajustes.meta.resale.after": "%",
    "cs.ajustes.meta.resale.aria": "Goal for what you resell as is, in %",
    "cs.ajustes.meta.hint": "Between 10% and 80%. Typical for cooked food: between 28% and 35%.",
    "cs.ajustes.meta.err": "It has to be between 10 and 80.",
    "cs.ajustes.meta.saved": "Your goal is now {pct}%",
    "cs.ajustes.cats.t": "Which categories do you resell?",
    "cs.ajustes.cats.d": "Their dishes are compared with the goal for what you resell.",
    "cs.ajustes.cats.included": "Already included with {name}",
    "cs.ajustes.cats.none": "Your menu has no categories with dishes yet.",
    "cs.ajustes.gastos.t": "Kitchen costs",
    "cs.ajustes.gastos.d": "Gas, power, disposables and seasonings. A % is added to the cost of the ingredients.",
    "cs.ajustes.gastos.before": "Add",
    "cs.ajustes.gastos.after": "% to the ingredients",
    "cs.ajustes.gastos.aria": "Kitchen costs, in %",
    "cs.ajustes.gastos.err": "It has to be between 0 and 50.",
    "cs.ajustes.outOfRange": "You have {pct}% saved: it's outside {lo}–{hi}%. If you change it, it has to be inside.",
    "cs.ajustes.gastos.example": "E.g.: {plato} has {plata} in ingredients → {extra} in kitchen costs.",
    "cs.ajustes.gastos.exampleGeneric": "E.g.: a dish with {plata} in ingredients → {extra} in kitchen costs.",
    "cs.ajustes.gastos.noteStrong": "Wages and rent do NOT go here:",
    "cs.ajustes.gastos.note": "they come out of what you keep.",
    "cs.ajustes.stock.t": "Stock on orders",
    "cs.ajustes.stock.block": "Don't allow selling what's sold out",
    "cs.ajustes.stock.on": "On:",
    "cs.ajustes.stock.onD": "waiters can't add a dish that's out of stock.",
    "cs.ajustes.stock.off": "Off:",
    "cs.ajustes.stock.offD": "they see \"Sold out\" but can add it anyway.",
    "cs.ajustes.stock.savedOn": "Done: sold-out dishes can't be sold",
    "cs.ajustes.stock.savedOff": "Done: sold-out dishes can still be added",
    "cs.ajustes.stock.loading": "Reading how it's set up…",
    "cs.ajustes.ignored.t": "Items that aren't food",
    "cs.ajustes.ignored.d": "Don't warn if they don't deduct stock (delivery, cover charge, tip).",
    "cs.ajustes.ignored.none": "None",
    "cs.ajustes.ignored.edit": "Choose",
    "cs.ajustes.ignored.done": "Done",
    "cs.ajustes.ignored.hint": "Tick the ones that have no recipe on purpose.",
    "cs.ajustes.ignored.search": "Search the menu…",
    "cs.ajustes.ignored.empty": "No dishes with that name.",
    "cs.ajustes.ignored.more": "There are {n} more: search them by name.",
    "cs.ajustes.pack.t": "Stock with Store Management",
    "cs.ajustes.pack.d": "Stock goes down with every sale, waiters see \"Sold out\" and you count the fridge on one sheet.",
    "cs.ajustes.pack.cta": "Ask about it",
    "cs.ajustes.pack.ctaAria": "Ask on WhatsApp (opens in a new tab)",
    "cs.ajustes.pack.wa": "Hi! I'd like to know about Store Management for {local}: stock that goes down with every sale.",
    "cs.ajustes.sheet.title": "Your goal",
    "cs.ajustes.sheet.q": "Out of every {cobras} you charge, how much do you want to spend on ingredients, at most?",
    "cs.ajustes.sheet.other": "Other",
    "cs.ajustes.sheet.otherLabel": "How much, out of every $100?",
    "cs.ajustes.sheet.of100": "of $100",
    "cs.ajustes.sheet.echo": "Out of every {cobras}, up to {plata} on ingredients ({pct}% of the price).",
    "cs.ajustes.sheet.echoNone": "Pick a value between 10 and 80.",
    "cs.ajustes.sheet.hint": "Typical: between $28 and $35.",
    "cs.ajustes.sheet.resale": "What you resell as is has its own goal ({pct}%).",
    "cs.ajustes.sheet.resaleLink": "Change it in Settings",
  },

  pt: {
    "cs.platos.eyebrow": "Seus números",
    "cs.platos.title": "Pratos",
    "cs.platos.sub": "Quanto custa cada prato e quanto sobra para você.",
    "cs.platos.subStock": "Quanto custa cada prato, quanto sobra e para quantos ainda dá.",
    "cs.platos.act.contar": "Contar",
    "cs.platos.act.compra": "Registrar compra",

    "cs.platos.kpi.queda.label": "Sobra por prato",
    "cs.platos.kpi.queda.avg": "em média",
    "cs.platos.kpi.queda.progress": "{n} de {total} com custo",
    "cs.platos.kpi.queda.short": "{n} de {total}",
    "cs.platos.kpi.queda.aria": "{n} de {total} pratos com custo",
    "cs.platos.kpi.queda.costOne": "Custear o que falta",
    "cs.platos.kpi.queda.costMany": "Custear os {n} que faltam",
    "cs.platos.kpi.meta.label": "Sua meta",
    "cs.platos.kpi.meta.value": "Ingredientes: até {pct}% do preço",
    "cs.platos.kpi.meta.resale": "Bebidas e revenda: até {pct}%",
    "cs.platos.kpi.meta.short": "Meta: ingredientes até {pct}%",
    "cs.platos.kpi.meta.change": "Mudar",
    "cs.platos.kpi.meta.changeAria": "Mudar sua meta",
    "cs.platos.kpi.platos.one": "1 prato",
    "cs.platos.kpi.platos.other": "{n} pratos",
    "cs.platos.kpi.see": "Ver quais",
    "cs.platos.kpi.revisar.label": "Para revisar",
    "cs.platos.kpi.revisar.none": "Nenhum",
    "cs.platos.kpi.revisar.sub": "deixam menos do que você quer",
    "cs.platos.kpi.revisar.subNone": "os custeados cumprem sua meta",
    "cs.platos.kpi.stock.label": "Estoque",
    "cs.platos.kpi.stock.outNone": "Nada esgotado",
    "cs.platos.kpi.stock.out.one": "1 sem estoque",
    "cs.platos.kpi.stock.out.other": "{n} sem estoque",
    "cs.platos.kpi.stock.low": "{n} para repor",
    "cs.platos.kpi.stock.lowIncl": "{n} para repor (com os sem estoque)",
    "cs.platos.kpi.stock.uncounted": "{n} sem contar",
    "cs.platos.kpi.stock.see": "Ver insumos",
    "cs.platos.kpi.start.value": "Controle aqui",
    "cs.platos.kpi.start.sub": "Baixa sozinho a cada venda e o garçom vê \"Esgotado\"",
    "cs.platos.kpi.start.link": "Começar",
    "cs.platos.kpi.nodesc.label": "Não descontam",
    "cs.platos.kpi.nodesc.none": "Todos descontam",
    "cs.platos.kpi.nodesc.sub": "que você vendeu não baixam o estoque",
    "cs.platos.kpi.nodesc.subNone": "o que você vendeu baixou o estoque",
    "cs.platos.kpi.nodesc.subMissing": "não conseguimos ler as vendas",
    "cs.platos.mstock.label": "Estoque:",
    "cs.platos.mstock.start": "comece a controlar",
    "cs.platos.reventa.only": "Mostrando só o que você revende.",
    "cs.platos.reventa.all": "Ver todos",
    "cs.platos.stockLoading": "Lendo o estoque…",

    "cs.platos.check.title": "Comece aqui · {done} de {total}",
    "cs.platos.check.sub": "Saiba quanto cada prato deixa. Leva uns 15 minutos.",
    "cs.platos.check.hide": "Ocultar",
    "cs.platos.check.done": "feito",
    "cs.platos.check.tag": "Gestão",
    "cs.platos.check.count": "{n} de {total}",
    "cs.platos.check.goal.t": "Sua meta",
    "cs.platos.check.goal.d": "De cada $100 que você cobra, quanto quer gastar em ingredientes, no máximo?",
    "cs.platos.check.goal.done": "De cada $100 que você cobra, até {plata} em ingredientes.",
    "cs.platos.check.goal.other": "Outro",
    "cs.platos.check.goal.hint": "O comum: entre $28 e $35.",
    "cs.platos.check.cost5.t": "Custeie {goal} pratos",
    "cs.platos.check.cost5.d": "Comece por um; ao salvar, você segue para o próximo sem voltar à lista.",
    "cs.platos.check.cost5.first": "Custear o primeiro: {name}",
    "cs.platos.check.cost5.next": "Custear o próximo: {name}",
    "cs.platos.check.cost5.short": "Custear",
    "cs.platos.check.prices.t": "Revise o preço dos {n} insumos que mais pesam",
    "cs.platos.check.prices.tNone": "Revise o preço dos insumos que mais pesam",
    "cs.platos.check.prices.d": "Abre \"Revisar preços\" com esses {n} já carregados.",
    "cs.platos.check.prices.dNone": "Aparece quando você custear os primeiros pratos.",
    "cs.platos.check.prices.cta": "Revisar preços",
    "cs.platos.check.stock.t": "Controle seu estoque",
    "cs.platos.check.stock.d": "10 minutos: escolha o que controlar, conte o que tem e pronto.",
    "cs.platos.check.stock.dCount.one": "Falta contar 1 insumo.",
    "cs.platos.check.stock.dCount.other": "Faltam contar {n} insumos.",
    "cs.platos.check.stock.cta": "Ver como",
    "cs.platos.check.stock.ctaCount": "Contar",
    "cs.platos.check.strip.one": "Falta 1 passo:",
    "cs.platos.check.strip.other": "Faltam {n} passos:",
    "cs.platos.check.strip.stock": "Controlar o estoque",
    "cs.platos.check.strip.count": "Contar o estoque",
    "cs.platos.check.strip.aria": "Passos que faltam",

    "cs.platos.alert.more.one": "e mais 1",
    "cs.platos.alert.more.other": "e mais {n}",
    "cs.platos.alert.less": "Ocultar",
    "cs.platos.alert.open": "Ver avisos",
    "cs.platos.alert.count.one": "1 aviso",
    "cs.platos.alert.count.other": "{n} avisos",
    "cs.platos.alert.salesError": "Não conseguimos ler as vendas: o estoque pode estar inflado.",
    "cs.platos.alert.salesErrorStale": "Não conseguimos ler as vendas novas: o estoque pode estar inflado.",
    "cs.platos.alert.stockError": "Não conseguimos ler o estoque. Recarregue a página.",
    "cs.platos.alert.brokenUnit": "{plato}: \"{ing}\" está em {en} e você compra por {por}. Não soma nem desconta.",
    "cs.platos.alert.brokenGeneric": "{plato}: a unidade de \"{ing}\" não bate com como você compra. Não soma nem desconta.",
    "cs.platos.alert.brokenDeleted": "{plato}: leva um ingrediente que não existe mais. Não soma.",
    "cs.platos.alert.brokenInner": "{plato}: o preparo \"{ing}\" tem uma linha que não soma.",
    "cs.platos.alert.noPrice.one": "{name} não tem preço e 1 prato usa: fica incompleto.",
    "cs.platos.alert.noPrice.other": "{name} não tem preço e {n} pratos usam: ficam incompletos.",
    "cs.platos.alert.outOfStock": "{name}: sem estoque.",
    "cs.platos.alert.oversold": "{name}: vendeu-se mais do que tinha. Conte de novo.",
    "cs.platos.alert.currency": "Seus custos estão em {costs} e o cardápio em {menu}.",
    "cs.platos.alert.trackedUnused": "Você controla {name} mas nenhum prato usa: só baixa com o que você lançar à mão.",
    "cs.platos.alert.colors": "Mudamos como os pratos são coloridos: agora só comparamos o que você gasta em ingredientes, e as bebidas têm sua própria meta.",
    "cs.platos.unitIn.g": "gramas",
    "cs.platos.unitIn.kg": "quilos",
    "cs.platos.unitIn.ml": "mililitros",
    "cs.platos.unitIn.l": "litros",
    "cs.platos.unitIn.u": "unidades",
    "cs.platos.unitIn.doc": "dúzias",
    "cs.platos.unitBy.g": "grama",
    "cs.platos.unitBy.kg": "quilo",
    "cs.platos.unitBy.ml": "mililitro",
    "cs.platos.unitBy.l": "litro",
    "cs.platos.unitBy.u": "unidade",
    "cs.platos.unitBy.doc": "dúzia",
    "cs.platos.fix.retry": "Tentar de novo",
    "cs.platos.fix.reload": "Recarregar",
    "cs.platos.fix.fix": "Corrigir",
    "cs.platos.fix.price": "Pôr preço",
    "cs.platos.fix.buy": "Registrar compra",
    "cs.platos.fix.count": "Contar",
    "cs.platos.fix.settings": "Ajustes",
    "cs.platos.fix.see": "Ver",
    "cs.platos.fix.ok": "Entendi",

    "cs.platos.search.placeholder": "Buscar prato ou categoria…",
    "cs.platos.search.label": "Buscar prato ou categoria",
    "cs.platos.search.clear": "Apagar busca",
    "cs.platos.cat.label": "Categoria",
    "cs.platos.cat.all": "Categoria: todas",
    "cs.platos.filter.aria": "Filtrar pratos",
    "cs.platos.filter.todos": "Todos",
    "cs.platos.filter.revisar": "Para revisar",
    "cs.platos.filter.sincostear": "Sem custo",
    "cs.platos.filter.bien": "Vão bem",
    "cs.platos.filter.nodescuentan": "Não descontam",
    "cs.platos.list.aria": "Pratos do cardápio",
    "cs.platos.col.plato": "Prato",
    "cs.platos.col.costo": "Custo",
    "cs.platos.col.precio": "Preço",
    "cs.platos.col.queda": "Sobra",
    "cs.platos.col.stock": "Estoque",
    "cs.platos.row.sizes": "{n} tamanhos",
    "cs.platos.row.resale": "revenda",
    "cs.platos.row.approx": "aproximado",
    "cs.platos.row.pct": "{pct}% ingred.",
    "cs.platos.row.suggest": "cobre {plata}",
    "cs.platos.row.suggestLabel": "{label}: cobre {plata}",
    "cs.platos.row.missing": "falta o preço de {name}",
    "cs.platos.row.noAmount": "falta a quantidade de {name}",
    "cs.platos.row.broken": "uma linha não soma",
    "cs.platos.row.noPrice": "o cardápio não tem preço",
    "cs.platos.row.sold": "vendeu {n}",
    "cs.platos.row.soldWhy": "vendeu {n} · {why}",
    "cs.platos.row.partial": "(o resto desconta)",
    "cs.platos.row.costear": "Custear",
    "cs.platos.row.costearAria": "Custear {name}",
    "cs.platos.count.one": "1 prato",
    "cs.platos.count.other": "{n} pratos",

    "cs.platos.empty.menu.t": "Seu cardápio ainda não tem pratos",
    "cs.platos.empty.menu.d": "Cadastre no editor e volte aqui para saber quanto cada um deixa.",
    "cs.platos.empty.menu.cta": "Ir ao editor",
    "cs.platos.empty.all": "Ver todos",
    "cs.platos.empty.filter.t": "Não há pratos com esse filtro",
    "cs.platos.empty.search.t": "Não encontramos \"{q}\"",
    "cs.platos.empty.search.d": "Tente outra palavra ou o nome da categoria.",
    "cs.platos.empty.revisar.t": "Nada para revisar",
    "cs.platos.empty.revisar.d": "Os pratos que você custeou cumprem sua meta.",
    "cs.platos.empty.sincostear.t": "Você já custeou todos os pratos",
    "cs.platos.empty.sincostear.d": "Quando somar um ao cardápio, ele aparece aqui.",
    "cs.platos.empty.bien.t": "Nenhum prato vai bem ainda",
    "cs.platos.empty.bien.d": "Custeie seus pratos ou revise os que deixam menos.",
    "cs.platos.empty.nodesc.t": "Tudo o que você vendeu desconta do estoque",
    "cs.platos.empty.nodesc.d": "Se um prato vendido não baixar o estoque, ele aparece aqui com o motivo.",

    "cs.ajustes.eyebrow": "Como calculamos",
    "cs.ajustes.title": "Ajustes",
    "cs.ajustes.sub": "O que você mudar aqui vale para todos os pratos.",
    "cs.ajustes.saved": "Ajustes salvos",
    "cs.ajustes.chip": "{n}%",
    "cs.ajustes.meta.t": "Sua meta",
    "cs.ajustes.meta.example": "De cada {cobras} que você cobra, até {plata} em ingredientes.",
    "cs.ajustes.meta.cook.before": "Pratos que você cozinha: até",
    "cs.ajustes.meta.cook.after": "% do preço",
    "cs.ajustes.meta.cook.aria": "Meta dos pratos que você cozinha, em %",
    "cs.ajustes.meta.presets": "Metas comuns",
    "cs.ajustes.meta.resale.before": "O que você revende como está (bebidas, sobremesas compradas): até",
    "cs.ajustes.meta.resale.after": "%",
    "cs.ajustes.meta.resale.aria": "Meta do que você revende como está, em %",
    "cs.ajustes.meta.hint": "Entre 10% e 80%. O comum na cozinha: entre 28% e 35%.",
    "cs.ajustes.meta.err": "Tem que estar entre 10 e 80.",
    "cs.ajustes.meta.saved": "Sua meta ficou em {pct}%",
    "cs.ajustes.cats.t": "Quais categorias você revende?",
    "cs.ajustes.cats.d": "Seus pratos são comparados com a meta do que você revende.",
    "cs.ajustes.cats.included": "Já vai com {name}",
    "cs.ajustes.cats.none": "Seu cardápio ainda não tem categorias com pratos.",
    "cs.ajustes.gastos.t": "Gastos de cozinha",
    "cs.ajustes.gastos.d": "Gás, luz, descartáveis e temperos. Soma-se um % ao custo dos ingredientes.",
    "cs.ajustes.gastos.before": "Some",
    "cs.ajustes.gastos.after": "% aos ingredientes",
    "cs.ajustes.gastos.aria": "Gastos de cozinha, em %",
    "cs.ajustes.gastos.err": "Tem que estar entre 0 e 50.",
    "cs.ajustes.outOfRange": "Você tem {pct}% salvo: está fora de {lo}–{hi}%. Se mudar, tem que ficar dentro.",
    "cs.ajustes.gastos.example": "Ex.: {plato} leva {plata} em ingredientes → {extra} de gastos de cozinha.",
    "cs.ajustes.gastos.exampleGeneric": "Ex.: um prato com {plata} em ingredientes → {extra} de gastos de cozinha.",
    "cs.ajustes.gastos.noteStrong": "Salários e aluguel NÃO entram aqui:",
    "cs.ajustes.gastos.note": "saem do que sobra para você.",
    "cs.ajustes.stock.t": "Estoque na comanda",
    "cs.ajustes.stock.block": "Não deixar vender o esgotado",
    "cs.ajustes.stock.on": "Ligado:",
    "cs.ajustes.stock.onD": "o garçom não pode lançar um prato sem estoque.",
    "cs.ajustes.stock.off": "Desligado:",
    "cs.ajustes.stock.offD": "vê \"Esgotado\" mas pode lançar mesmo assim.",
    "cs.ajustes.stock.savedOn": "Pronto: o esgotado não pode ser vendido",
    "cs.ajustes.stock.savedOff": "Pronto: o esgotado pode ser lançado mesmo assim",
    "cs.ajustes.stock.loading": "Lendo como está configurado…",
    "cs.ajustes.ignored.t": "Itens que não são comida",
    "cs.ajustes.ignored.d": "Não avisar se não descontam estoque (entrega, couvert, gorjeta).",
    "cs.ajustes.ignored.none": "Nenhum",
    "cs.ajustes.ignored.edit": "Escolher",
    "cs.ajustes.ignored.done": "Pronto",
    "cs.ajustes.ignored.hint": "Marque os que não têm receita de propósito.",
    "cs.ajustes.ignored.search": "Buscar no cardápio…",
    "cs.ajustes.ignored.empty": "Não há pratos com esse nome.",
    "cs.ajustes.ignored.more": "Há mais {n}: busque pelo nome.",
    "cs.ajustes.pack.t": "Estoque com Gestão do local",
    "cs.ajustes.pack.d": "O estoque baixa sozinho a cada venda, o garçom vê \"Esgotado\" e você conta a geladeira numa planilha.",
    "cs.ajustes.pack.cta": "Consultar",
    "cs.ajustes.pack.ctaAria": "Consultar pelo WhatsApp (abre em outra aba)",
    "cs.ajustes.pack.wa": "Olá! Quero saber da Gestão do local para {local}: o estoque que baixa sozinho a cada venda.",
    "cs.ajustes.sheet.title": "Sua meta",
    "cs.ajustes.sheet.q": "De cada {cobras} que você cobra, quanto quer gastar em ingredientes, no máximo?",
    "cs.ajustes.sheet.other": "Outro",
    "cs.ajustes.sheet.otherLabel": "Quanto, de cada $100?",
    "cs.ajustes.sheet.of100": "de $100",
    "cs.ajustes.sheet.echo": "De cada {cobras}, até {plata} em ingredientes ({pct}% do preço).",
    "cs.ajustes.sheet.echoNone": "Escolha um valor entre 10 e 80.",
    "cs.ajustes.sheet.hint": "O comum: entre $28 e $35.",
    "cs.ajustes.sheet.resale": "O que você revende como está tem sua própria meta ({pct}%).",
    "cs.ajustes.sheet.resaleLink": "Mudar em Ajustes",
  },
};

export default platos;
